import { EKeycardType, ERegistrationStep } from '../reducers';

export const CHECK_PHONE_VERIFY_REQUEST = {
  request: 'loyaltyRegistrationModal/CHECK_PHONE_VERIFY/request',
  loading: 'loyaltyRegistrationModal/CHECK_PHONE_VERIFY/loading',
  success: 'loyaltyRegistrationModal/CHECK_PHONE_VERIFY/success',
  failure: 'loyaltyRegistrationModal/CHECK_PHONE_VERIFY/failure',
};

export const GENERATE_CODE_REQUEST = {
  request: 'loyaltyRegistrationModal/GENERATE_CODE_REQUEST/request',
  loading: 'loyaltyRegistrationModal/GENERATE_CODE_REQUEST/loading',
  success: 'loyaltyRegistrationModal/GENERATE_CODE_REQUEST/success',
  failure: 'loyaltyRegistrationModal/GENERATE_CODE_REQUEST/failure',
};

export const VERIFY_CODE_REQUEST = {
  request: 'loyaltyRegistrationModal/VERIFY_CODE_REQUEST/request',
  loading: 'loyaltyRegistrationModal/VERIFY_CODE_REQUEST/loading',
  success: 'loyaltyRegistrationModal/VERIFY_CODE_REQUEST/success',
  failure: 'loyaltyRegistrationModal/VERIFY_CODE_REQUEST/failure',
};

export const CREATE_LOYALTY_REQUEST = {
  request: 'loyaltyRegistrationModal/CREATE_LOYALTY_REQUEST/request',
  loading: 'loyaltyRegistrationModal/CREATE_LOYALTY_REQUEST/loading',
  success: 'loyaltyRegistrationModal/CREATE_LOYALTY_REQUEST/success',
  failure: 'loyaltyRegistrationModal/CREATE_LOYALTY_REQUEST/failure',
};

export const REGISTRATION_MODAL = {
  resetStore: 'loyaltyRegistrationModal/resetStore',
  open: 'loyaltyRegistrationModal/OPEN',
  close: 'loyaltyRegistrationModal/CLOSE',
  setStep: 'loyaltyRegistrationModal/setStep',
  setForcedPhoneNumber: 'loyaltyRegistrationModal/setForcedPhoneNumber',
  setChooseKeycardData: 'loyaltyRegistrationModal/setChooseKeycardData',
  setPhoneNumber: 'loyaltyRegistrationModal/setPhoneNumber',
  setLoadingText: 'loyaltyRegistrationModal/setLoadingText',
  setPreselectCard: 'loyaltyRegistrationModal/setPreselectCard',
  setModalOpenFrom: 'loyaltyRegistrationModal/setModalOpenFrom',
  setRefreshLoyaltyAccountDataStorage: 'loyaltyRegistrationModal/setRefreshLoyaltyAccountDataStorage',
};

interface ICreateLoyaltyRequestActionParams {
  keycardType: EKeycardType;
  marketingConsent: boolean;
}

interface ICreateLoyaltySuccessActionParams {
  keycardType: EKeycardType;
  cardNumber: string;
}

interface ISetForcedPhoneNumber {
  forcedPhoneNumber: string;
}

interface ISetPhoneNumber {
  phoneNumber: string;
}

export type LoyaltyRegistrationModalEvents = {
  'loyaltyRegistrationModal/CHECK_PHONE_VERIFY/request': unknown;
  'loyaltyRegistrationModal/CHECK_PHONE_VERIFY/loading': unknown;
  'loyaltyRegistrationModal/CHECK_PHONE_VERIFY/success': unknown;
  'loyaltyRegistrationModal/CHECK_PHONE_VERIFY/failure': string;
  'loyaltyRegistrationModal/GENERATE_CODE_REQUEST/request': { phoneNumber: string };
  'loyaltyRegistrationModal/GENERATE_CODE_REQUEST/loading': unknown;
  'loyaltyRegistrationModal/GENERATE_CODE_REQUEST/success': unknown;
  'loyaltyRegistrationModal/GENERATE_CODE_REQUEST/failure': string;
  'loyaltyRegistrationModal/VERIFY_CODE_REQUEST/request': { phoneNumber: string; code: string };
  'loyaltyRegistrationModal/VERIFY_CODE_REQUEST/loading': unknown;
  'loyaltyRegistrationModal/VERIFY_CODE_REQUEST/success': unknown;
  'loyaltyRegistrationModal/VERIFY_CODE_REQUEST/failure': string;
  'loyaltyRegistrationModal/CREATE_LOYALTY_REQUEST/request': ICreateLoyaltyRequestActionParams;
  'loyaltyRegistrationModal/CREATE_LOYALTY_REQUEST/loading': unknown;
  'loyaltyRegistrationModal/CREATE_LOYALTY_REQUEST/success': ICreateLoyaltySuccessActionParams;
  'loyaltyRegistrationModal/CREATE_LOYALTY_REQUEST/failure': string;
  'loyaltyRegistrationModal/OPEN': unknown;
  'loyaltyRegistrationModal/CLOSE': unknown;
  'loyaltyRegistrationModal/setStep': ERegistrationStep;
  'loyaltyRegistrationModal/setForcedPhoneNumber': ISetForcedPhoneNumber;
  'loyaltyRegistrationModal/setPhoneNumber': ISetPhoneNumber;
  'loyaltyRegistrationModal/resetStore': unknown;
  'loyaltyRegistrationModal/setChooseKeycardData': { keycardType: EKeycardType; marketingConsent: boolean };
  'loyaltyRegistrationModal/setLoadingText': { text: string };
  'loyaltyRegistrationModal/setPreselectCard': { preselecrCard: EKeycardType };
  'loyaltyRegistrationModal/setModalOpenFrom': { from: string };
  'loyaltyRegistrationModal/setRefreshLoyaltyAccountDataStorage': {
    refreshLoyaltyAccountDataStorage: boolean;
  };
};
